import angular from 'angular';

export default function PreparationItemController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  attachPreparationItemDialog,
  confirmDialog,
  docDataService,
  serviceIds,
  editPreparationItemCommentDialog,
  editPreparationItemDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.AM;

  vm.canExpand = vm.status !== 'No Preparation Item Added';
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpandPreparationItem = _handleExpandPreparationItem;
  vm.handleEditPreparationItem = _handleEditPreparationItem;
  vm.handleDeletePreparationItem = _handleDeletePreparationItem;
  vm.handleAddPreparationItemNote = _handleAddPreparationItemNote;
  vm.handleMarkStatusComplete = _handleMarkStatusComplete;
  vm.handleAttachItems = _handleAttachItems;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleConfirmComplete = _handleConfirmComplete;
  vm.handleCancelComplete = _handleCancelComplete;

  _activate();

  // //////// METHODS //////////

  _initEventListeners();


  function _activate() {
    _setStatuses();
    const dfdActivate = $q.defer();

    _refreshPreparationItemStatuses().then(
      _refreshUsers().then(dfdActivate.resolve)
    );
  }

  function _initEventListeners() {
    $scope.$on('refreshAMUsers', _refreshUsers);

    $scope.$on('refreshAMPreparationItem', (event, opt) => {
      if (opt.preparationItemId === vm.preparationItem.preparationItemId) {
        _refreshPreparationItem();
      }
    });

    $scope.$on('refreshAMPreparationItemComments', (event, opt) => {
      if (opt.preparationItemId === vm.preparationItem.preparationItemId) {
        _refreshPreparationItemComments();
      }
    });

    $scope.$on('refreshAMPreparationItemFolders', (event, opt) => {
      if (opt.preparationItemId === vm.preparationItem.preparationItemId) {
        _refreshPreparationItemFolders();
      }
    });

    $scope.$on('refreshAMPreparationItemReports', (event, opt) => {
      if (opt.preparationItemId === vm.preparationItem.preparationItemId) {
        _refreshPreparationItemReports();
      }
    });

    $scope.$on('refreshAMPreparationItemDocuments', (event, opt) => {
      if (opt.preparationItemId === vm.preparationItem.preparationItemId) {
        _refreshPreparationItemDocuments();
      }
    });

    $scope.$on('refreshFolderAttachments', () => {
      _refreshPreparationItemFolders();
      _refreshPreparationItemDocuments();
      _refreshPreparationItemReports();
    });

    $scope.$on('refreshDocAttachments', (event, opt) => {
      let docisAttached = false;
      angular.forEach(vm.preparationItem.preparationItemDocuments, (preparationItemDocument) => {
        if (preparationItemDocument.documentId === opt.document.documentId) {
          docisAttached = true;
        }
      });

      if (docisAttached) {
        _refreshPreparationItemDocuments();
      }
    });
  }

  function _setStatuses() {
    vm.preparationItem.canAddItemNote = (vm.preparationItem.canAddNote || vm.preparationItem.isAssignedToMe)
      && vm.auditIsActive;
    vm.preparationItem.canAttachItemItems = (vm.preparationItem.canAttachItems || vm.preparationItem.isAssignedToMe)
      && vm.auditIsActive;
    vm.preparationItem.canChangeItemStatus = (vm.preparationItem.canChangeStatus || vm.preparationItem.isAssignedToMe
        || vm.preparationItem.canEdit) && vm.preparationItem.statusId !== 3 && vm.auditIsActive;
    vm.preparationItem.canEditItem = vm.preparationItem.canEdit && vm.auditIsActive;
    vm.preparationItem.canDeleteItem = vm.preparationItem.canDelete && vm.auditIsActive;
  }

  function _handleExpandPreparationItem() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshPreparationItem();
    }
  }

  function _refreshPreparationItem() {
    const dfdRefresh = $q.defer();

    amDataService.getPreparationItem(vm.preparationItem.preparationItemId).then((response) => {
      vm.preparationItem = response.data;
      _setStatuses();
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshPreparationItemComments() {
    const dfdRefresh = $q.defer();

    amDataService.getPreparationItemCommentsByPreparationItem(vm.preparationItem.preparationItemId)
      .then((response) => {
        vm.preparationItem.preparationItemComments = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }

  function _refreshPreparationItemFolders() {
    const dfdRefresh = $q.defer();

    amDataService.getPreparationItemFoldersByPreparationItem(vm.preparationItem.preparationItemId)
      .then((response) => {
        vm.preparationItem.preparationItemFolders = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }

  function _refreshPreparationItemDocuments() {
    const dfdRefresh = $q.defer();

    amDataService.getPreparationItemDocumentsByPreparationItem(vm.preparationItem.preparationItemId)
      .then((response) => {
        vm.preparationItem.preparationItemDocuments = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }


  function _refreshPreparationItemReports() {
    const dfdRefresh = $q.defer();

    amDataService.getPreparationItemReportsByPreparationItem(vm.preparationItem.preparationItemId)
      .then((response) => {
        vm.preparationItem.preparationItemReports = response.data.result;
        dfdRefresh.resolve();
      });

    return dfdRefresh.promise;
  }

  function _refreshPreparationItemStatuses() {
    const dfdRefresh = $q.defer();

    vm.statuses = amSharedModelService.preparationItemStatuses;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshUsers() {
    const dfdRefresh = $q.defer();

    vm.users = amSharedModelService.applicationUsers;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _handleEditPreparationItem($event) {
    loaderService.showViewLoader = true;
    _refreshPreparationItem().then(() => {
      ssDialogService.dialogs.auditTrail.editPreparationItemDialog = ssDialogService.alert(
        editPreparationItemDialog.getOptions($event, {
          customerId: vm.customerId,
          auditId: vm.auditId,
          auditIsActive: vm.auditIsActive,
          statuses: vm.statuses,
          users: vm.users,
          preparationItem: vm.preparationItem,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemDialog);
    });
  }

  function _handleAddPreparationItemNote($event) {
    ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog = ssDialogService.alert(
      editPreparationItemCommentDialog.getOptions($event, {
        preparationItemId: vm.preparationItem.preparationItemId,
        preparationItemCommentId: -1,
        preparationItemCommentText: '',
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.editPreparationItemCommentDialog);
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then((getFolderResponse) => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.auditTrail.attachPreparationItemDialog = ssDialogService.alert(
        attachPreparationItemDialog.getOptions($event, {
          serviceId: vm.serviceId,
          preparationItemId: vm.preparationItem.preparationItemId,
          folder: vm.rootFolder,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.attachPreparationItemDialog);
    });
  }

  // /////////////// Delete /////////////////
  function _handleDeletePreparationItem($event) {
    ssDialogService.dialogs.auditTrail.deletePreparationItemConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Preparation Item?',
        message: `Are you sure you want to delete Preparation Item "${vm.preparationItem.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deletePreparationItemConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amSharedModelService.deletePreparationItem(vm.preparationItem)
      .then(() => {
        // deleteCallback is wrapped in a function by Angular
        vm.deleteCallback()(vm.preparationItem);
        alerts.success('The Preparation Item has been deleted successfully.');
        $rootScope.$broadcast('refreshNotifications');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Preparation Item.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deletePreparationItemConfirmDialog);
  }

  // /////////////// Complete /////////////////

  function _handleMarkStatusComplete($event) {
    ssDialogService.dialogs.auditTrail.completePreparationItemConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Complete Preparation Item?',
        message: `Are you sure you want to mark Preparation Item "${vm.preparationItem.description}" as completed?`,
        handleYesClick: _handleConfirmComplete,
        handleNoClick: _handleCancelComplete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.completePreparationItemConfirmDialog);
  }

  function _handleConfirmComplete() {
    loaderService.showViewLoader = true;
    amDataService.setPreparationItemStatus(vm.preparationItem.preparationItemId, 3).then((response) => {
      if (response.status !== 201) {
        alerts.error('Error occurred while marking the Preparation Item complete.');
      } else {
        loaderService.showViewLoader = false;
        alerts.success('The Preparation Item has successfully been marked as complete.');
        $rootScope.$broadcast('refreshAMPreparationItem', { preparationItemId: vm.preparationItem.preparationItemId });
        $rootScope.$broadcast('refreshNotifications');
        _closeCompleteDialog();
      }
    });
  }

  function _handleCancelComplete() {
    _closeCompleteDialog();
  }

  function _closeCompleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.completePreparationItemConfirmDialog);
  }
}

PreparationItemController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'attachPreparationItemDialog',
  'confirmDialog',
  'docDataService',
  'serviceIds',
  'editPreparationItemCommentDialog',
  'editPreparationItemDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
